import {ValueObject} from '@s-ui/domain'

export class GetConversationUserParamsRequest extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.adId
   * @param {String} data.partnerId
   * @param {String} data.userId
   **/

  static validate({adId, userId, userConversationError}) {
    const checkParamExists = param => param !== undefined && param !== null

    if (!checkParamExists(adId)) {
      throw userConversationError('Ad id is undefined or null.')
    }
    if (!checkParamExists(userId)) {
      throw userConversationError('User id is undefined or null.')
    }
  }

  getAdId() {
    return this._adId
  }

  getPartnerId() {
    return this._partnerId
  }

  getUserId() {
    return this._userId
  }
}
